export default __webpack_public_path__ + "static/banner_0-43c75d086d83d8e22766baa2e31c3323.webp";